import React, { FC, MouseEvent, ReactNode, useContext } from 'react';
import { A } from './A';
import { RoutingContext } from '../contexts';

export type LinkProps = {
  href: string;
  children: ReactNode;
  className?: string;
  onContextMenu?: (e: MouseEvent<HTMLAnchorElement>) => void;
  tabIndex?: number;
  block?: boolean;
  plain?: boolean;
};

export const Link: FC<LinkProps> = ({
  href,
  children,
  className,
  onContextMenu,
  tabIndex,
  block,
  plain,
}) => {
  const { route } = useContext(RoutingContext);

  return (
    <A
      href={href}
      onClick={e => {
        if (e.metaKey || e.button !== 0) return;
        e.preventDefault();
        route(href);
      }}
      className={className}
      onContextMenu={onContextMenu}
      tabIndex={tabIndex}
      block={block}
      plain={plain}
    >
      {children}
    </A>
  );
};
